import React, { useEffect, useRef } from 'react';
import { motion, useInView, useAnimation } from 'framer-motion';

// @desc Second Animation Component
export const LateWrapper = ({ children }) => {
  const lateRef = useRef(null);
  const isInView = useInView(lateRef, { once: true });

  const mainControls = useAnimation();

  const animationVariant = {
    hidden: { opacity: 0, y: 75 },
    visible: { opacity: 1, y: 0 },
  };

  useEffect(() => {
    if (isInView) {
      mainControls.start('visible');
    }
  }, [isInView, mainControls]);

  return (
    <div ref={lateRef} style={{ position: 'relative', overflow: 'hidden' }}>
      <motion.div
        variants={animationVariant}
        initial='hidden'
        animate={mainControls}
        transition={{ duration: 0.8, delay: 0.75 }}
      >
        {children}
      </motion.div>
    </div>
  );
};
